<template>
  <preview :activity="activity" :btnEditar="false"/>
  <!--<h1>Mostrar material del id: {{$route.params.id}}</h1>-->
</template>
<script>
import preview from "@/components/preview/Preview";
import MaterialService from "@/services/material.service";
import { constants } from 'fs';

export default {
  name: "MostrarMaterial",
  components: {
    preview
  },
  data() {
    return {
      paramsList: {
        paginate: false,
        filtro: {
          _id: null
        }
      },
      activityData: {
        info: {
          desc: null,
          title: null
        },
        content: []
      }
    };
  },
  mounted() {
    this.paramsList.filtro._id = this.$route.params.id;
    MaterialService.list(1, this.paramsList).then(response => {      
      this.activityData.info.desc = response[0].description;
      this.activityData.info.title = response[0].title;
      this.activityData.content = response[0].content;
      console.log(this.activityData.info);
    });
  },
  computed: {
    activity() {
      return this.activityData;
    }
  }
};
</script>